/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PurchaseDetail } from './PurchaseDetail';
import {
    PurchaseDetailFromJSON,
    PurchaseDetailFromJSONTyped,
    PurchaseDetailToJSON,
} from './PurchaseDetail';

/**
 * 
 * @export
 * @interface Purchase
 */
export interface Purchase {
    /**
     * 
     * @type {Array<PurchaseDetail>}
     * @memberof Purchase
     */
    purchaseDetails?: Array<PurchaseDetail>;
}

/**
 * Check if a given object implements the Purchase interface.
 */
export function instanceOfPurchase(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PurchaseFromJSON(json: any): Purchase {
    return PurchaseFromJSONTyped(json, false);
}

export function PurchaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): Purchase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'purchaseDetails': !exists(json, 'purchaseDetails') ? undefined : ((json['purchaseDetails'] as Array<any>).map(PurchaseDetailFromJSON)),
    };
}

export function PurchaseToJSON(value?: Purchase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'purchaseDetails': value.purchaseDetails === undefined ? undefined : ((value.purchaseDetails as Array<any>).map(PurchaseDetailToJSON)),
    };
}

